import { create } from 'zustand';
import { usePermStore } from './permStore';

interface User {
  id: string; email: string; fullName: string; role: string; branchId: string | null;
}

interface AuthState {
  user:        User | null;
  accessToken: string | null;
  isLoggedIn:  boolean;
  superadmin:  boolean;   // aktuální relace je připojený správce podpory (superadmin)
  login:  (user: User, token: string, refreshToken?: string | null, superadmin?: boolean) => void;
  logout: () => void;
  /** Srovná roli a pobočku podle serveru (správce je mohl mezitím změnit). */
  syncUser: (role: string, branchId: string | null) => void;
  /** Srovná lokální příznak podle toho, co říká server (viz SuperadminBanner). */
  setSuperadmin: (v: boolean) => void;
}

// Načteme uložený stav z localStorage při startu
function loadState(): Pick<AuthState, 'user' | 'accessToken' | 'isLoggedIn' | 'superadmin'> {
  try {
    const token = localStorage.getItem('access_token');
    const user  = localStorage.getItem('auth_user');
    if (token && user) {
      return { accessToken: token, user: JSON.parse(user), isLoggedIn: true, superadmin: localStorage.getItem('sa_session') === '1' };
    }
  } catch (_) { /* ignorovat */ }
  return { accessToken: null, user: null, isLoggedIn: false, superadmin: false };
}

export const useAuthStore = create<AuthState>()((set) => ({
  ...loadState(),

  login: (user, accessToken, refreshToken, superadmin = false) => {
    localStorage.setItem('access_token', accessToken);
    if (refreshToken) localStorage.setItem('refresh_token', refreshToken);
    localStorage.setItem('auth_user', JSON.stringify(user));
    if (superadmin) localStorage.setItem('sa_session', '1');
    else localStorage.removeItem('sa_session');
    set({ user, accessToken, isLoggedIn: true, superadmin });
  },

  setSuperadmin: (v) => {
    if (v) localStorage.setItem('sa_session', '1');
    else   localStorage.removeItem('sa_session');
    set({ superadmin: v });
  },

  syncUser: (role, branchId) => set(st => {
    if (!st.user || (st.user.role === role && st.user.branchId === branchId)) return st;
    const user = { ...st.user, role, branchId };
    try { localStorage.setItem('auth_user', JSON.stringify(user)); } catch { /* plné úložiště */ }
    return { user };
  }),

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('auth_user');
    localStorage.removeItem('sa_session');
    usePermStore.getState().clear();
    set({ user: null, accessToken: null, isLoggedIn: false, superadmin: false });
  },
}));
